export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";